import { IcArrow } from '@assets/icons/24x24';
import { HStack, Icon, IconButton } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useSensorInstallationContext } from '../SensorInstallationContext';
import { useSensorEditingContext } from './SensorEditingContext';

export default function SensorFormNavigationArrows() {
  const { progress, steps, currentStep, currentSubStep, goBack, goNext, validationSchema } = useSensorEditingContext();
  const { values } = useFormikContext();
  const { isNewSensor } = useSensorInstallationContext();

  const validationFields = currentSubStep?.validationFields ?? currentStep.validationFields ?? [];
  const partialSchema = validationSchema?.pick(validationFields);
  const [isStepValid, setIsStepValid] = useState(false);

  useEffect(() => {
    partialSchema
      ?.validate(values, { abortEarly: false })
      .then(() => setIsStepValid(true))
      .catch(() => setIsStepValid(false));
  }, [values, partialSchema]);

  const isLastStep =
    progress.stepIndex === steps.length - 1 &&
    (!currentStep.children || progress.subStepIndex === currentStep.children.length - 1);

  useHotkeys('left', () => {
    if (progress.stepIndex !== 0) {
      goBack();
    }
  });

  useHotkeys('right', () => {
    if ((!isNewSensor || isStepValid) && !isLastStep) {
      goNext();
    }
  });

  return (
    <HStack gap={0} bottom={3} right={3} position="absolute" border="2px solid" borderColor="neutral.850">
      <IconButton
        boxSize="48px"
        variant="headOption"
        aria-label="back"
        onClick={goBack}
        disabled={progress.stepIndex === 0}
      >
        <Icon as={IcArrow} transform="rotate(180deg)" boxSize="24px" />
      </IconButton>
      <IconButton
        boxSize="48px"
        variant="headOption"
        aria-label="next"
        onClick={() => goNext()}
        disabled={(isNewSensor && !isStepValid) || isLastStep}
      >
        <Icon as={IcArrow} boxSize="24px" />
      </IconButton>
    </HStack>
  );
}
